import { type FC } from 'react';

import { type SizeProps } from '../../types/sizes';
import { FullyConstrainedSize } from '../structural/FullyConstrainedSize';
import { Stack, type StackProps } from '../structural/Stack';

export interface ContentProps extends Omit<
  StackProps,
  'direction' | 'flexGrow' | 'overflow' | SizeProps
> {}

export const Content: FC<ContentProps> = ({ children, ...props }) => (
  <FullyConstrainedSize
    {...props}
    component={Stack}
    direction='row'
    flexGrow={100}
    minHeight={0}
    overflow='hidden'
    width='100%'
  >
    {children}
  </FullyConstrainedSize>
);
